module.exports = __webpack_public_path__ + "img/dp-gr-sy1.48ae7e6e.png";